<ifc-id-verse-header [logoUrl]="headerLogoUrl"></ifc-id-verse-header>

<div class="notice">
  <span>IMPORTANT:</span>
  <span>Verification must be completed ONLY by the applicant.</span>
</div>

<mat-divider
  *ngIf="deviceData?.type === DeviceType.Desktop"
  class="divider"
></mat-divider>

<section class="content">
  <ng-container *ngIf="deviceData?.type === DeviceType.Desktop; else mobileView">
    <div class="qr">
      <h2 class="qr__title">
        Scan the QR code using your smartphone camera to complete your ID
        verification, then return here and press CONTINUE.
      </h2>
      <qrcode
        [qrdata]="verificationUrl"
        [width]="100"
        [errorCorrectionLevel]="'M'"
        [imageSrc]="qrLogoUrl"
        [imageHeight]="24"
        [imageWidth]="24"
        [margin]="1"
      >
      </qrcode>
    </div>
  </ng-container>

  <ng-template #mobileView>
    <p class="mobile-instructions">
      Upon clicking CONTINUE you will be redirected to the verification system.
    </p>
  </ng-template>
  <button
    mat-flat-button
    color="primary"
    class="continue-button"
    (click)="onClickContinue()"
  >
    CONTINUE
  </button>
</section>
